import { useBoolean } from '@aibees/shared/hooks';
import { DashboardSidebarItem } from '@aibees/shared/layouts/dashboard/types';
import { classnames, stringEquals } from '@aibees/shared/utils';
import { memo, useState } from 'react';
import * as SidebarStyled from '../../styles';
import { getHumanizedAppName } from '../../utils';
import { AppBadgeName } from '../app-badge-name';
import { AppSidebar } from '../app-sidebar';
import * as Styled from './styles';
import type { SidebarItemsMiniProps as Props } from './types';

export const SidebarItemsMini = memo(({ options, onOpenSidbar }: Props) => {
  const sidebarState = useBoolean(false);
  const [appMenu] = useState<DashboardSidebarItem>({} as DashboardSidebarItem);

  // TODO Move the map body to another component and memoize the icon prop value
  return (
    <Styled.Wrapper>
      {options?.items.map((item) => {
        const active =
          stringEquals(getHumanizedAppName(), item.title) ||
          stringEquals(appMenu.title, item.title);
        return (
          <SidebarStyled.ButtonWrapper key={item.title}>
            <SidebarStyled.Button
              onClick={onOpenSidbar}
              className={classnames({ active })}
              icon={item.icon?.(
                { sx: { opacity: item.enabled ? 1 : 0.2 } },
                active
              )}
            />
            <AppBadgeName appName={item.title} />
          </SidebarStyled.ButtonWrapper>
        );
      })}
      <AppSidebar state={sidebarState} menu={appMenu} />
    </Styled.Wrapper>
  );
});

SidebarItemsMini.displayName = 'SidebarItemsMini';
